import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot,CanActivate,Router,RouterStateSnapshot} from '@angular/router';
import {Principal} from 'src/app/core';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {StateStorageService} from './state-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DataManagementGuardService implements CanActivate {

  constructor(
    private router: Router,
    private principal: Principal,
    private stateStorageService: StateStorageService
) {}

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    const authorities = route.data['authorities'];
    
    return this.checkAccountingPermission(authorities, state.url);
}

checkAccountingPermission(authorities: string[], url: string): Promise<boolean> {
    const principal = this.principal;
    return Promise.resolve(
        principal.identity().then(account => {
            if (!authorities || authorities.length === 0) {
                return true;
            }

          if(account) {
            if(RoleUtil.isStaff(account.userRole)) {
              if(url.includes("underwriter")) {
                this.principal.hasStaffPermission("underwritersInsurer").then(per => {
                  if(per){
                    return true;
                  } else {
                    // this.stateStorageService.storeUrl(url);
                      this.router.navigate([ 'accessdenied' ]).then(() => {
                          localStorage.clear();
                        // only show the login dialog, if the user hasn't logged in yet
                        if (!account) {
                            // this.stateStorageService.storeUrl('/');
                            //  this.loginModalService.open();
                        }
                    });
                  
                  }
                })
              }
            } 
          }
          return true;
        })
    );
  }
}
